export default {
  salesCount: 0,
  sumSales: 0,
  salesCountInMonth: 0,

  visits: [],
  mostVisited: [],
  mostVisitPerDay: [],
  mostVisitPerHour: [],
  mostVisitPerCountry: [],
  visitorsList: [],

  services: [],
  service: [],

  waitingTickets: [],
  answeredTickets: [],
  closedTickets: [],
  ticket: {},
  ticketCategories: [],

  brands: [],
  brand: [],
  festivalDiscounts: [],

  categoryChilds: [],
  productFeatures: [],
  productFeaturesByCategory: [],
  productFeatureDetails: [],
  ProductFeatureDetailsByFeatureId: [],
  products: [],
  product: {},
  productImages: [],

  outOfStocks: [],

  newReturns: [],
  checkedReturns: [],

  factor: [],

  contactMessages: [],
  newsLetters: [],

  team: [],

  faqs: [],
  faq: {},
};
